import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ARService } from '../../ar.service';
import { PaymentReceiptModel } from 'src/app/models/accountsReceivable/payment-receipt.model';
import { MatSnackBar } from '@angular/material/snack-bar';
import moment from 'moment';
import { LEDGER_ITEM_TYPE } from 'src/app/models/constants/ledger-item-type.model';

@Component({
  standalone: false,
  selector: 'app-ar-card-payment-receipt',
  templateUrl: './ar-card-payment-receipt.component.html',
  styleUrls: ['./ar-card-payment-receipt.component.scss']
})
export class ArCardPaymentReceiptComponent implements OnInit {

  isLoading: boolean = true;
  paymentReceipt: PaymentReceiptModel = new PaymentReceiptModel();
  paymentId: string = '';
  errorMessage: string = '';  
  moment = moment;  
  showPaymentAgreement: boolean = false;

  constructor(private arService: ARService,
    private snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private changeRef: ChangeDetectorRef) {
  }

  async ngOnInit(): Promise<void> {
    this.route.paramMap.subscribe((params) => { //router is ActivatedRoute
      this.paymentId = params.get('paymentId');
    });
    // Perform authentication check using the token
    if (this.paymentId) {
      // Get Payment Info
      const promises: any[] = [];
      promises.push(this.arService.getPaymentReceipt(this.paymentId).toPromise());
      try {

        const results: any[] = await Promise.all(promises);
        this.paymentReceipt = results[0];
        if (this.paymentReceipt.PaymentTypeId === LEDGER_ITEM_TYPE.CreditPayment) 
          this.showPaymentAgreement = true;
        this.isLoading = false;
        this.changeRef.detectChanges();
      } catch (err) {
        console.log(err);
        this.errorMessage = 'Unable to fetch payment receipt';
        this.createMessage('Something went wrong', 'Error');
        this.isLoading = false;
        this.changeRef.detectChanges();
      }
    } else {
      // Token is missing, handle unauthorized access
      this.isLoading = false;
      this.changeRef.detectChanges();
    }
  }

  createMessage(message, type) {
    this.snackBar.open(message, type, {
      duration: 3000,
      verticalPosition: 'top'
    });
  }

  print(){
    window.print();
  }
}
